<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="events.icon" class="mr-1"></i>
            <span>{{ events.title }}</span>
          </b-col>
        </b-row>
      </b-card-header>

      <div v-show="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-show="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event Code" label-size="sm" class="mb-0">
                  <b-input-group class="treeselect_all justify-content-end pr-2px">
                    <span style="padding-top: 0.3em" class="text-primary" id="eventlike-tooltip">Like</span>
                    <b-form-checkbox id="eventlike" v-model="eventlike_visible" class="z-0">
                    </b-form-checkbox>
                  </b-input-group>
                  <b-input-group v-if="!eventlike_visible">
                    <treeselect placeholder="Select event..." searchPromptText="Type at least 3 chars..." v-model="code"
                      :multiple="false" :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                      :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                      search-nested>
                      <div slot="value-label" slot-scope="{ node }">
                        {{ node.raw.id }}
                      </div>
                    </treeselect>
                  </b-input-group>
                </b-form-group>
                <b-input-group v-if="eventlike_visible">
                  <b-form-input v-model="eventlike" :debounce="events.debounce" placeholder="Event Code (LIKE %)"
                    trim></b-form-input>
                  <b-input-group-append>
                    <b-button size="sm" variant="outline-secondary" :disabled="!eventlike" @click="eventlike = ''">
                      <i class="fa fa-remove"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <!-- </b-form-group> -->
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event Code" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="code" :debounce="events.debounce" placeholder="Event Code"
                      trim></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!code" @click="code = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->


              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label-cols="12"
                    label="Event Date From"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="datefrom"
                        size="sm"
                        label-help
                        hide-header
                        locale="en-GB"
                        placeholder="Select date"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      ></b-form-datepicker>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="datefrom = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label-cols="12"
                    label="Event Date To"
                    label-size="sm"
                  >
                    <b-input-group>
                      <b-form-datepicker
                        v-model="dateto"
                        size="sm"
                        label-help
                        hide-header
                        locale="en-GB"
                        placeholder="Select date"
                        :date-format-options="{
                          year: 'numeric',
                          month: 'numeric',
                          day: 'numeric',
                        }"
                      ></b-form-datepicker>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="dateto = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event Name" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="description" :debounce="events.debounce"
                      placeholder="Event Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!description" @click="description = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Budget Code" label-size="sm">
                  <treeselect instanceId="budget" type="number" v-model="budget" :clearable="true"
                    :options="budget_options" :multiple="true"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="VAT Region" label-for="vatregion" label-cols="12" size="sm">
                  <treeselect instanceId="vatregion" type="number" v-model="vatregion" :clearable="true"
                    :options="vatregion_options"></treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group label-cols="12" label="Event Date" label-size="sm">
                  <!-- :timePicker="true"
                        :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker size="sm" ref="date" v-model="start_at" :opens="'right'" :locale-data="locale_data"
                      :ranges="locale_ranges" :showDropdowns="true" :linkedCalendars="false"
                      :single-date-picker="false">
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" @click="
                        start_at = {
                          startDate: null,
                          endDate: null,
                        }
                        ">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label="Closed?" label-for="closed" label-cols="12">
                  <treeselect instanceId="onstop" type="number" v-model="closed" :clearable="true"
                    :options="closed_options"></treeselect>
                </b-form-group>
              </b-col>
              <!--   <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Closed?"
                    label-for="closed"
                    label-cols="12"
                  >
                    <b-input-group class="z-0">
                      <b-form-radio-group
                        id="closed"
                        v-model="closed"
                        :options="[
                          { text: 'Yes', value: true },
                          { text: 'No', value: false },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="closed = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col> -->
            </b-row>
          </b-card-body>
        </b-card>
        <div id="events" class="px-3 mx-0 text-left">

          <div v-if="events.pastespecial">
            <b-row class="mt-2" no-gutters>
              <b-col cols="6">
                <b-form-group>
                  <b-form-checkbox-group id="segments_paste_selected" v-model="events.paste_selected"
                    :options="events.paste_options" value-field="id" text-field="label"></b-form-checkbox-group>
                </b-form-group>
              </b-col>
              <b-col cols="auto" class="text-right ml-auto">
                <b-row>
                  <!-- <b-col cols="auto">
                    <b-link squared size="sm" variant="outline-primary" @click="download()">
                      <i class="fa fa-download"></i>
                      Template
                    </b-link>
                  </b-col> -->
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="events_saveit()">
                      <i class="fa fa-floppy-o"></i>
                      Save It
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="events_headers()">
                      Headers
                    </b-link>
                  </b-col>
                  <b-col cols="auto">
                    <b-link size="sm" variant="outline-primary" @click="events_paste_read()">
                      <i class="fa fa-magic"></i>
                      Read It
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label-cols="12">
                  <b-form-textarea id="data" v-model="events.paste" placeholder="Paste event data" rows="6"
                    class="smalltextarea courier"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </div>

          <d-table classdivtable="availtable datatable" refid="events" :icon="events.icon" :busy="events.busy"
            :toolbarlibrary="events.toolbarlibrary" :tools="events.tools" :badges="events.badges"
            :fields="events.fields" :items="events.items" :offset="events.offset" :limit="events.limit"
            :downloaded="events.downloaded" :page="events.page" @load="events_load" @click="events_click"
            @changed="events_click('save', $event)" @select="events_select">
          </d-table>
        </div>
      </div>

      <div v-show="component">
        <component :is="component" :selection="events.selected" :config="events.action ? { action: events.action } : {}"
          @discard="events_click('discard')">
        </component>
      </div>
      <b-card-footer class="mt-2 ml-1">
        <div class="text-center">
          <b-button squared size="sm" variant="outline-primary" @click="$emit('discard')">
            <i class="fa fa-cogs mr-2"></i>Setup All
          </b-button>
        </div>
      </b-card-footer>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import dateparse from 'any-date-parser';

import EventEdit from "./Components/Setup_EventsEditN";

export default {
  name: "EventsN",
  components: { EventEdit },
  watch: {
    async start_at() {
      await this.events_load(0);
    },
    async code() {
      if (this.code) {
        this.start_at = { startDate: null, endDate: null }
      } else {
        this.start_at = { startDate: this.$moment().startOf('year').format("YYYY-MM-DD"), endDate: this.$moment().add(1, "year").endOf("year").format("YYYY-MM-DD") }
      }
      await this.events_load()
    },
    async eventlike_visible() {
      if (this.eventlike_visible) {
        this.code = null
        this.start_at = { startDate: null, endDate: null }
      } else {
        this.eventlike = null
        this.start_at = { startDate: this.$moment().startOf('year').format("YYYY-MM-DD"), endDate: this.$moment().add(1, "year").endOf("year").format("YYYY-MM-DD") }
      }
      await this.events_load();
    },

    async eventlike() {
      await this.events_load();
    },
    async description() {
      await this.events_load(0);
    },
    async budget() {
      await this.events_load(0);
    },
    async vatregion() {
      await this.events_load(0);
    },
    async closed() {
      await this.events_load(0);
    },
  },
  data() {
    return {
      start_at: {
        startDate: this.$moment().startOf('year').format("YYYY-MM-DD"),
        endDate: this.$moment()
          .add(1, "year")
          .endOf("year")
          .format("YYYY-MM-DD"),
      },
      code: null,
      eventlike: null,
      eventlike_visible: null,
      description: null,
      budget: [],
      vatregion: null,
      closed: null,
      closed_options: [
        {
          id: "1",
          label: "Yes",
        },
        {
          id: "0",
          label: "No",
        },
      ],
      budget_options: [],
      vatregion_options: [
        { id: "EEC", label: "EEC" },
        { id: "NEEC", label: "NEEC" },
        { id: "UK", label: "UK" },
      ],

      events: {
        title: "Events SQL",
        icon: "fa fa-calendar-check-o",
        debounce: 500,
        busy: false,
        denied: [],
        page: 1,
        offset: 0,
        limit: 15,
        action: null,
        tools: "go,filter,download,clipboard,add,copy,edit,pastespecial,deleteconfirm",
        toolbarlibrary: [],
        edit: false,
        pastespecial: false,
        paste: null,
        paste_selected: ["firstrowheader", "reversenamecap"],
        paste_options: [
          { id: "firstrowheader", label: "First Row Headers", disabled: true },
          { id: "secondrowskip", label: "Second Row Skip" },
          { id: "filldown", label: "Fill Down" },
        ],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-right text-primary w-50px",
          },
          {
            key: "code",
            label: "Event Code",
            sortable: true,
          },
          {
            key: "start_at",
            label: "Date Event",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY");
              }
              return result;
            },
          },
          {
            key: "description",
            label: "Event Name",
            sortable: true,
          },
          {
            key: "budget",
            label: "Budget Code",
            sortable: true,
          },
          // {
          //   key: "salesgroup",
          //   label: "Sales Group",
          //   sortable: true,
          // },
          {
            key: "vatregion",
            label: "VAT Region",
            sortable: true,
          },
          {
            key: "closed",
            label: "Closed",
            sortable: true,
          },
          {
            key: "updated_by",
            label: "Updated By",
            sortable: true,
            class: "text-center w-100px",
          },
          {
            key: "updated_at",
            label: "Updated At",
            sortable: true,
            class: "text-right w-100px",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [
          // {
          //   key: "closed",
          //   type: "badge",
          //   Yes: "danger",
          //   No: "success",
          //   formatter: (value, key, item) => {
          //     if (value == false) {
          //       return "No";
          //     } else if (value == true) {
          //       return "Yes";
          //     } else {
          //       return "";
          //     }
          //   },
          // },
          {
            key: "closed",
            type: "badge",
            Yes: "danger",
            No: "success",

            formatter: (value, key, item) => {
              switch (value) {
                case "true":
                  return "Yes";

                case "false":
                  return "No";

                default:
                  return value;
              }
            },
          },


          {
            key: "vatregion",
            type: "badge",
            EEC: "primary",
            NEEC: "danger",
            UK: "info",
          },
        ],
        items: [],
        selected: [],
        downloaded: [],
        denied: [],
      },
    };
  },
  async mounted() {

    await this.loadDDL();

    await this.events_load();
  },

  methods: {
    async loadDDL() {
      //this.busy = true;

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_budgets {
                setup_budgets {
                  id
                  label
                }
              }
            `,
        });
        this.budget_options = response.data.setup_budgets;
      } catch (error) {
        console.log(error);
      }

      this.busy = false;
    },
    async events_load(offset, limit, page) {

      let state = this.events;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }


      // NO WILDCARD SEARCHES
      if (
        !this.start_at.startDate &&
        !this.start_at.endDate &&
        !this.code &&
        !this.description &&
        !this.budget &&
        !this.vatregion &&
        !this.closed
      ) {
        return;
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,
        fuzzy: this.code ? this.code : this.description ? this.description : null,
        eventlike: this.eventlike,
        start_at: [this.start_at.startDate, this.start_at.endDate],
        budget: this.budget.length > 0 ? this.budget.join(",") : null,
        vatregion: this.vatregion,
        closed: this.closed,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.query({
          query: gql`
              query setup_events(
                $limit: Int
                $offset: Int
                $fuzzy: String
                $eventlike: String
                $code: String
                $description: String
                $start_at: [String]
                $budget: String
                $vatregion: String
                $closed: String            
              ) {
                setup_events(
                  limit: $limit
                  offset: $offset
                  fuzzy:$fuzzy
                  eventlike: $eventlike
                  code: $code
                  description: $description
                  start_at: $start_at
                  budget: $budget
                  vatregion: $vatregion
                  closed: $closed                
                ) {
                  id
                  code
                  description
                  start_at
                  salesgroup
                  vatregion
                  budget
                  closed
                  updated_by
                  updated_at
                  rows
                }
              }
            `,
          variables,
        });

        // USE LOCAL VARIABLE
        // if (limit == 0) {
        //   state.selected = response.data.events
        // } else {
        //   state.items = []
        //   state.items = response.data.events;
        // }

        state.downloaded = []
        if (limit == 0) {
          state.downloaded = response.data.setup_events
        } else {
          state.items = []
          state.items = response.data.setup_events;
        }


        //  this.events.items = response.data.events;
      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async events_click(a, ss) {
      console.log("events_click", a, ss);

      let state = this.events;
      state.action = null;

      switch (a) {
        case "download_view":
          state.downloaded = []
          state.downloaded = state.items
          break;

        case "download_all":
          state.downloaded = []
          await this.events_load(0, 0);
          break;
        case "filter":
          this.showfilter = !this.showfilter;
          break;
        case "discard":
        case "go":
          this.component = null;
          await this.events_load();
          break;

        case "pastespecial":
          state.pastespecial = !state.pastespecial
          if (!state.pastespecial) {
            state.paste = null
            await this.events_load();
          }
          break;

        case "add":
        case "edit":
          this.component = "EventEdit";
          await this.events_load(0);
          break;

        case "copy":
          state.action = "copy";
          this.component = "EventEdit";
          await this.events_load(0);
          break;

        case "save":
          await this.events_saveit(ss);
          break;

        case "delete":
          await this.events_deleteit(ss);
          break;
      }
    },
    async events_select(ss, tools) {

      let state = this.events;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "clipboard", "add", "download", "pastespecial"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["copy", "edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async events_paste_read() {

      let state = this.events;

      if (state.paste) {
        state.busy = true
        let rows = this.$helpers.tabToObjArr(state.paste)

        let rowstart = 1
        if (state.paste_selected.includes("secondrowskip")) {
          rowstart += 1
        }

        // MAKE OBJECT ITEMS
        let items = []
        for (let i = rowstart; i < rows.length; i++) {
          items.push(rows[i])
        }

        if (state.paste_selected.includes("filldown")) {
          let lastitem = {}
          for (let i = 0; i < items.length; i++) {
            let item = items[i]
            for (let prop in lastitem) {
              if (!item[prop]) {
                if (lastitem[prop]) {
                  item[prop] = lastitem[prop]
                }
              }
            }
            lastitem = item
          }
        }

        let found = null

        console.log(items)

        rows = []
        for (let i = 0; i < items.length; i++) {
          let obj = items[i]

          let event = {}

          for (let prop in obj) {

            let values = []
            try {
              if (obj[prop]) {
                let data = obj[prop].trim()
                let colname = prop.toLowerCase()

                if (colname == 'code' || colname == 'event code') {
                  event.code = data.toUpperCase()
                }
                if (colname == 'description' || colname == 'event name' || colname == 'event description') {
                  event.description = data
                }
                if (colname == 'budget' || colname == 'budget code') {
                  event.budget = data.toUpperCase()
                }
                if (colname == 'salesgroup' || colname == 'sales group') {
                  event.salesgroup = data.toUpperCase()
                }
                if (colname == 'vatregion' || colname == 'vat region') {
                  event.vatregion = data.toUpperCase()
                }
                if (colname == 'start_at' || colname == 'event start date') {
                  if (data.length != 10) { data = "0" + data }
                  let st = dateparse.fromString(data.split("/").join("-").split(".").join("-"));
                  console.log('parsed as', st)
                  event.start_at = this.$moment(st).utc(true).format('YYYY-MM-DD')
                }
                if (colname == 'end_at' || colname == 'event end date') {
                  if (data.length != 10) { data = "0" + data }
                  let st = dateparse.fromString(data.split("/").join("-").split(".").join("-"));
                  console.log('parsed as', st)
                  event.dateend = this.$moment(st).utc(true).format('YYYY-MM-DD')
                }
              }

            } catch (error) {
              console.log('error here', error)
            }
          }
          // DE-DUPLICATE
          found = rows.find(o => o.code == event.code)
          if (!found) {
            rows.push(event)
          }
        }
        console.log('rows=', rows)

        state.items = rows

        state.busy = false
      }

    },
    async events_headers() {

      let state = this.events;

      let content = state.paste
      state.paste = "SLAC\tPO\n"
      if (content) {
        state.paste += content
      }
    },

    async events_saveit(ss) {

      let state = this.events;

      state.busy = true;

      let variables = { rows: this.cleanit(state.items) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation events_save(
                $rows: [Event_input]             
              ) {
                events_save(rows: $rows) {
                  id
                  code
                  description
                  start_at
                  dateend
                  salesgroup
                  vatregion
                  budget
                  closed
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      state.busy = false;
    },
    async events_deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation setup_events_delete(
                $rows: [setup_events_input]
              ) {
                setup_events_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.events_load(0);
    },
  },
};
</script>

<style></style>